import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

import { currentEnv } from '../common';
import { getConfig } from '../stake';

export const AXIOS_DEFAULT_CONFIG: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
};

export interface IGetStatsResponse {
  ratio: number;
  tvl: string;
  apy: number;
  stakers: number;
  // eslint-disable-next-line camelcase
  epoch_started_at: number;
  // eslint-disable-next-line camelcase
  iota_price: number;
  // eslint-disable-next-line camelcase
  boosted_apy: number;
}

export class AnalyticsApi {
  private static instance?: AnalyticsApi;

  public api: AxiosInstance;

  private constructor() {
    AnalyticsApi.instance = this;

    this.api = axios.create({
      ...AXIOS_DEFAULT_CONFIG,
      baseURL: getConfig(currentEnv).api,
    });
  }

  public static getInstance(): AnalyticsApi {
    if (AnalyticsApi.instance) {
      return AnalyticsApi.instance;
    }

    return new AnalyticsApi();
  }

  async getStats(): Promise<IGetStatsResponse> {
    const { data } = await this.api.get(`/v1/stats`);

    return data;
  }
}
